export default {
    mapId: s => s.mapId,
    minLine: s => s.minLine,
    minStep: s => s.minStep,
    curLevelText: s => s.curLevelText,
    maskBox: s => s.maskBox,
    adoptDialog: s => s.adoptDialog,
    adoptChinaDialog: s => s.adoptChinaDialog,
    failDialog: s => s.failDialog,
    failDialogChina: s => s.failDialogChina,
    exitGameMode: s => s.exitGameMode,
    adoptTitle: s => s.adoptTitle,
    adoptText: s => s.adoptText,
    failText: s => s.failText,
    failTitle: s => s.failTitle,
    ideMask: s => s.ideMask,
    isLoading: s => s.isLoading,
    imagesLoaded: s => s.imagesLoaded,
    loadingText: s => s.loadingText,
    codeIndexDialog: s => s.codeIndexDialog,
    funArr: s => s.funArr,
    funVisibleArr: s => s.funVisibleArr,
    funIndex: s => s.funIndex,
    funShowCount: s => s.funShowCount,
    allArr: s => s.allArr,
    allImageMap: s => s.allImageMap,
    checkpointShow: s => s.checkpointShow,
    allBgMap: s => s.allBgMap,
    checkpointData: s => s.checkpointData,
    selectedPoint: s => s.selectedPoint,
    explainDialog: s => s.explainDialog,
    totalScore:s=>s.totalScore,
    tourCompelete:s=>s.tourCompelete,
    tourNotCompelete:s=>s.tourNotCompelete,
    tourCompeleteNotGet:s=>s.tourCompeleteNotGet,
    tourGameNotPass:s=>s.tourGameNotPass,

    configLine: s => s.configLine,
    configSteps: s => s.configSteps,
    curLine: s => s.curLine,
    curSteps: s => s.curSteps,
    star: s => s.star,
    toBack: s => s.toBack,
    knowledgeArr: s => s.knowledgeArr,
    CommandList: s => s.knowledgeArr,
    allStar: s => s.allStar,
    dirLang: s => s.dirLang,
    menuFlag: s => s.menuFlag,
    sessionShow: s => s.sessionShow,
    explainDialog1: s => s.explainDialog1,
    explainDialog2: s => s.explainDialog2,
    videoShow: s => s.videoShow,
    checkLangShow: s => s.checkLangShow,
    lang: s => s.lang,
    level: s => s.level,
    fullName: s => s.fullName,
    skipShow: s => s.skipShow,
    currentIndex: s => s.currentIndex,
    CommentImgList: s => s.CommentImgList,
    imagePath: s => s.imagePath,
    highCheckShow: s => s.highCheckShow,
    imgShow: s => s.imgShow,
    imgList: s => s.imgList,
    isLastLevel: s => s.isLastLevel,
    browserVersionShow: s => s.browserVersionShow,
    passAllLevelShow: s => s.passAllLevelShow,
    interfaceErrorShow: s => s.interfaceErrorShow,
    audioShow: s => s.audioShow,
    StoryIntroList: s => s.StoryIntroList,
    userFirstName: s => s.userFirstName,
    userLastName: s => s.userLastName,
    currentLevel: s => s.currentLevel,
    isPassAllLevel: s => s.isPassAllLevel,
    skipStyleShow: s => s.skipStyleShow,
    skipNextShow: s => s.skipNextShow,
    qrCodeUrl: s => s.qrCodeUrl,
    qrCodeShow: s => s.qrCodeShow,
    getQRcode: s => s.getQRcode,
    qrCodeShow2: s => s.qrCodeShow2,
    codeShow: s => s.codeShow,
    blocklyShow: s => s.blocklyShow,
    Workspace: s => s.Workspace,
    chooseMode: s => s.chooseMode,
    userType: s => s.userType,
    pathAllImage: s => s.pathAllImage,
    blocklyText: s => s.blocklyText,
    justLastLevel: s => s.justLastLevel,
    xml_text: s => s.xml_text,
    blockly_json: s => s.blockly_json,
    blPython: s => s.blPython,
    maxHighlevel: s => s.maxHighlevel,
    checkLangDialogShow: s => s.checkLangDialogShow,
    checkLangs: s => s.checkLangs,
    gameId: s => s.gameId,
    monthlyGameShow: s => s.monthlyGameShow,
    ipShow: s => s.ipShow,
    times:s => s.times,
    competeType:s => s.competeType,
    edition:s => s.edition,
    isVip:s => s.isVip,
    timeoverShow:s => s.timeoverShow,
    timeText:s => s.timeText,
    loadingTimeShow:s => s.loadingTimeShow,
    courseTitleTxt:s=>s.courseTitleTxt,

    GameConfig: s => s.GameConfig,
};


// WEBPACK FOOTER //
// ./src/store/getters.js